import PropTypes from "prop-types";
import "../../../cuppa/components/cuppa.tooltip";
import {CuppaTooltip} from "../../../cuppa/components/cuppa.tooltip";

export function Tooltip(props){
	return(
		<cuppa-tooltip
			class={props.className}
			target={props.target}
			text={props.text}
			style={{...{fontSize:12, fontWeight:'normal'}, ...props.style}}
			pos-x={props.posX}
			pos-y={props.posY}
			arrow={props.arrow}
			style-arrow={props.styleArrow}
			force-show={props.forceShow}
		/>
	)
}

Tooltip.propTypes = {text:PropTypes.string, style:PropTypes.any, target:PropTypes.string, posX:PropTypes.string, posY:PropTypes.string, arrow:PropTypes.string, styleArrow: PropTypes.any, forceShow:PropTypes.bool, className:PropTypes.string};
Tooltip.defaultProps = {text:'', style:null, target:'', posX:CuppaTooltip.POSITION.CENTER, posY:CuppaTooltip.POSITION.BOTTOM, arrow:CuppaTooltip.ARROW.UP, styleArrow:"", forceShow:false, className:''};
